<template>
  <footer class="footer has-background-black">
    <div class="container">
      <!-- Main container -->
      <nav class="level is-mobile">
        <!-- Left side -->
        <div class="level-left">
          <img class="logo" src="../assets/KnockOutFC-logo.png" />
        </div>
        <!-- Right side -->
        <div class="level-right"></div>
      </nav>
      <!-- <div class="content">
        <div class="columns has-text-light is-mobile">
          <div class="column is-size-7">
            <h1 class="title is-5 has-text-primary">Company</h1>
            <p>About us</p>
            <p>About founders</p>
            <p>Jobs</p>
            <p>Locate</p>
            <p>Blog</p>
          </div>
          <div class="column is-size-7">
            <h1 class="title is-5 has-text-primary">Services</h1>
            <p>MMA</p>
            <p>Self Development</p>
            <p>Retreats</p>
          </div>
          <div class="column"></div>
        </div>
      </div>-->
      <hr class="has-background-grey-dark" />
      <nav class="level is-mobile">
        <!-- Left side -->
        <div
          class="level-left has-text-white is-size-7"
        >© {{ new Date().getFullYear() }} Knockout Fight Club</div>
        <!-- Right side -->
        <div class="level-right">
          <div class="level-item has-text-weight-bold is-size-7 has-text-light">
            <a class="has-text-light" target="_blank" href="tel://9810075446">
              <b-icon pack="fab" icon="whatsapp" size="is-medium" href="/login"></b-icon>
            </a>
            <a class="has-text-light" target="_blank" href="https://www.facebook.com/kofightclub/">
              <b-icon pack="fab" icon="facebook" size="is-medium"></b-icon>
            </a>
            <!-- <a class="has-text-light" href="/aksjn">
              <b-icon pack="fab" icon="google" size="is-medium"></b-icon>
            </a>-->
            <a
              class="has-text-light"
              target="_blank"
              href="https://www.instagram.com/knockout_fight_club/?hl=en"
            >
              <b-icon pack="fab" icon="instagram" size="is-medium"></b-icon>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 100px;
}

hr {
  height: 1px;
}
</style>
